import React, { PropsWithChildren } from 'react';

import { ModalSectionCard } from '@/components/shared/ModalSectionCard';
import { ModalSectionTitle } from '@/components/shared/ModalSectionTitle';
import { classNames } from '@/helpers/classNames';

import styles from './AnalysisCard.module.scss';

const AnalysisCard: React.FC<
	PropsWithChildren<{
		className?: string;
		bottomAreaClassName?: string;
		title: string;
		responsiveArea?: React.ReactNode;
	}>
> = ({ children, className, bottomAreaClassName, title, responsiveArea }) => {
	return (
		<ModalSectionCard paddingSize="md">
			<div className={classNames([styles['root'], className])}>
				<ModalSectionTitle>{title}</ModalSectionTitle>

				{responsiveArea && (
					<div className={styles['responsive-area']}>
						{responsiveArea}
					</div>
				)}
				<div
					className={classNames([
						styles['bottom-area'],
						bottomAreaClassName,
					])}
				>
					{children}
				</div>
			</div>
		</ModalSectionCard>
	);
};

export default AnalysisCard;
